import { render, staticRenderFns } from "./exemptAdd.vue?vue&type=template&id=fd1a2e5a&"
import script from "./exemptAdd.vue?vue&type=script&lang=js&"
export * from "./exemptAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports